export function floatToInteger(value) {
    let val = ""
    val = parseFloat(value)
    
    if(val % 1 !== 0){
        return value
    } else {
        return Math.trunc(val);
    }
     
  
}